export default {
  state: {
    selection: {},
    defaultSelection: "4515",
    options: [],
  },

  mutations: {
    setSelection (state, selection) {
      state.selection = selection;
    },

    setOptions (state, options) {
      state.options = options;
    },
  }
};
